<!-- Modal Require Refund -->
<ng-template #content let-modal>
  <div [formGroup]="formGroup">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modalClose()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "REQUIRE_REFUND" | translate }}</h3>
      <div class="formGroup mb-1">
        <label [for]="'amount'">{{ "AMOUNT" | translate }}<sup class="text-danger">*</sup></label>
        <div class="input-group input-group-merge mb-1">
          <div class="input-group-prepend">
            <span class="input-group-text">&euro;</span>
          </div>
          <input placeholder="0.00" type="text" id="amount" class="form-control {{ fieldHasErrors('amount') ? 'is-invalid' : '' }}" formControlName="amount" (change)="formatNumber()" />
        </div>
        <div class="invalid-feedback" *ngIf="formGroup.controls.amount.errors?.required">{{ "ERRORS.INSERT_AMOUNT" | translate }}</div>
      </div>
      <div class="form-group mb-1">
        <label for="date">{{ "DAY" | translate | titlecase }}<sup class="text-danger">*</sup></label>
        <app-datepickr id="date" [displayMonths]="1" (onSelect)="formGroup.patchValue({date: $event})" [isInvalid]="!formGroup.value.date && showModalErrors"></app-datepickr>
      </div>
      <div class="form-group mb-1">
        <label for="note">{{ "NOTE" | translate }}</label>
        <textarea class="form-control" name="note" id="note" cols="45" rows="3" formControlName="note"></textarea>
      </div>
      <div class="form-group mb-1">
        <div class="col-12 p-0">
          <div class="row" *ngIf="attachments_list_obj.length < 1">
            <div class="col-12">
              <label for="note">{{ "FILE" | translate }}:<sup class="text-danger">*</sup></label>
              <div id="attachment-uploader" class="custom-file">
                <input class="custom-file-input" type="file" lang="it" id="attachment" [multiple]="false" (change)="addAttachmentToList($any($event).target.files)" accept="image/*, application/pdf, .doc, .docx" />
                <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-1" *ngIf="attachments_list_obj.length < 1">
              <div class="d-flex align-items-center justify-content-between">
                <div *ngIf="attachments_list_obj.length > 0">
                  <button class="btn btn-outline-danger" (click)="resetAttachmentsList()">{{ "RESET" | translate }}</button>
                </div>
              </div>
            </div>
            <div class="col-12  pt-1" *ngIf="attachments_list_obj.length > 0">
              <div *ngFor="let file of attachments_list_obj; let i = index" class="d-flex border-bottom mb-1 pb-1">
                <div class="flex-basis-80 d-flex align-items-center">
                  <div class="mr-05 cursor-pointer" (click)="removeAttachmentFromList(i)" *ngIf="file.status === 0">
                    <i [data-feather]="'x'" class="text-danger" size="18"></i>
                  </div>
                  <div class="mt-025">{{ file.name }}</div>
                </div>
                <div class="flex-basis-20 text-right">{{ file.size }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <a class="font-small-3 text-primary" (click)="_tutorialService.openTutorial('Richiesta Rimborso')">{{ "DONT_KNOW_HOW_TO_DO" | translate }}</a>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modalClose()">{{ "CANCEL" | translate }}</button>
      <button type="submit" (click)="requireRefund()" class="btn btn-primary w-150">{{ "SEND" | translate }}</button>
    </div>
  </div>
</ng-template>
<!-- / Modal Require refund -->